import { useParams } from 'react-router-dom';

import { useGetAiAgentAsCsFiles } from '../../../../../../shared/apis/ai-agent/ascs/reactQueries';

import AsCsPageLayout from '../Common/ui/AsCsPageLayout';
import useAiAgentAsCsFileFilters from './hooks/useAiAgentAsCsFileFilters';
import AsCsFileListTable from './ui/asCsFileListTable';
import AiAgentAsCsFileListFilterSection from './ui/filterSection';

export default function AiAgentAsCsFilesList() {
  const { companyId } = useParams();
  const {
    filterForm,
    queryParams,
    modelOptions,
    searchType,
    inputRef,
    updateFilterForm,
    handlePageChange,
    handleSearchType,
    handleSearch,
    resetSearchInput,
    resetFilters,
  } = useAiAgentAsCsFileFilters(Number(companyId));

  const { data: asCsFiles } = useGetAiAgentAsCsFiles(queryParams);

  return (
    <AsCsPageLayout>
      <AiAgentAsCsFileListFilterSection
        filterForm={filterForm}
        modelOptions={modelOptions}
        searchType={searchType}
        inputRef={inputRef}
        onChangeFilterForm={updateFilterForm}
        onChangeSearchType={handleSearchType}
        handleSearch={handleSearch}
        resetSearchInput={resetSearchInput}
        onReset={resetFilters}
      />
      <AsCsFileListTable
        list={asCsFiles}
        page={queryParams.page}
        size={queryParams.size}
        onPageChange={handlePageChange}
      />
    </AsCsPageLayout>
  );
}
